import "./isceco-polyfills.js";
(() => {
  window.iscecoWidgetLibrary = {
    iconCss: "https://cdn.jsdelivr.net/npm/fomantic-ui@2.9.2/dist/components/icon.min.css",
    languageKey: "widgetlib",
    supportedLanguages: ["de", "fr", "it", "en"]
  };
})();
